import useAppSettingsStore from '@/store/modules/appSettings.js';
import useLocaleStore from '@/store/modules/locale.js';
import { rtlLanguageList } from '@/constants/language.js';

const stylesheetLinkElIds = {
  puzzle: 'mini-game-puzzle-style',
  lantern: 'mini-game-lantern-style',
};

const useBonusGameHook = () => {
  const appSettingsStore = useAppSettingsStore();
  const localeStore = useLocaleStore();

  const addStylesheet = ({ id = 'mini-game-style', href = '' }) => new Promise((resolve) => {
    const linkEl = document.createElement('link');

    linkEl.id = id;
    linkEl.rel = 'stylesheet';
    linkEl.href = href;
    linkEl.onload = resolve;
    linkEl.onerror = resolve;

    document.head.appendChild(linkEl);
  });

  const removeStylesheet = ({ id }) => {
    const linkEl = document.getElementById(id);

    if (!linkEl) { return; }

    document.head.removeChild(linkEl);
  };

  const addPuzzleStylesheet = async () => {
    const getPuzzleStyleHref = (fileName) => `/static/mini_games/puzzle_game/${ fileName }.css`;

    await addStylesheet({
      id: stylesheetLinkElIds.puzzle,
      href: rtlLanguageList.includes(localeStore.currentLanguage)
        ? getPuzzleStyleHref(`${ appSettingsStore.appProperties.puzzleGameCss }_AR`)
        : getPuzzleStyleHref(appSettingsStore.appProperties.puzzleGameCss),
    });
  };

  const removePuzzleStylesheet = () => {
    removeStylesheet({ id: stylesheetLinkElIds.puzzle });
  };

  const addLanternStylesheet = async () => {
    const getLanternStyleHref = (fileName) => `/static/mini_games/lantern_game/${ fileName }.css`;

    await addStylesheet({
      id: stylesheetLinkElIds.lantern,
      href: rtlLanguageList.includes(localeStore.currentLanguage)
        ? getLanternStyleHref(`${ appSettingsStore.appProperties.fallingItemsGameCss }_AR`)
        : getLanternStyleHref(appSettingsStore.appProperties.fallingItemsGameCss),
    });
  };

  const removeLanternStylesheet = () => {
    removeStylesheet({ id: stylesheetLinkElIds.lantern });
  };

  return {
    addPuzzleStylesheet,
    removePuzzleStylesheet,
    addLanternStylesheet,
    removeLanternStylesheet,
  };
};

export default useBonusGameHook;
